namespace SP {
    export interface ReturnOrderInfo {
        orderId: string,
        customerId: string,
        orderNo: string,
        referenceNo: string,
        state: OrderState,
        sender: Address,
        recipient: Address,
        orderLines: OrderLineInfo[],
        shipments: ShipmentInfo[],
    }
}